import { Maximize2 } from "@/components/icons"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

type NodeEditDialogProps = {
  title: string
  description?: string
  className?: string
  allowLoopTokens?: boolean
  children: React.ReactNode
}

export function NodeEditDialog({
  title,
  description,
  className,
  allowLoopTokens = true,
  children,
}: NodeEditDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          aria-label={`Open ${title} editor`}
          className="nodrag size-6 p-0"
          size="icon"
          type="button"
          variant="ghost"
          onClick={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
        >
          <Maximize2 className="size-3.5" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className={cn(
          "max-h-[calc(100dvh-2rem)] gap-3 p-0 sm:max-w-[min(48rem,calc(100vw-2rem))]",
          className
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <DialogHeader className="border-b px-5 pt-5 pb-3">
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
          <p className="text-muted-foreground text-xs">
            {allowLoopTokens ? (
              <>
                Tip: use {"{input}"} for previous node output, {"{variableName}"} for workflow
                variables, and {"{{loop.item}}"} inside loops.
              </>
            ) : (
              <>
                Tip: use {"{input}"} for the incoming text and {"{variableName}"} for workflow
                variables.
              </>
            )}
          </p>
        </DialogHeader>
        <DialogBody className="px-5 pb-5">
          <div className="grid gap-4">{children}</div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
